// extracted by mini-css-extract-plugin
export default {"root":"Settlements_root__2YTR2","container":"Settlements_container__qCNXE"};